export default __webpack_public_path__ + "static/media/orden-venta-imprimir.8c7611d1.svg";